import React from 'react'
import classNames from 'classnames/bind'
import { USER_ROLES } from 'constants/user'
import AccessWrapper from 'apps/AccessWrapper'
import Button from 'elements/Button'
import { toCurrency } from 'utils/price'
import * as styles from './PlanItem.scss'
import { comparePlansScroller } from 'services/PageScroller'

const cx = classNames.bind(styles)

const PlanItem = ({ plan = {}, t, onSelectSubscriptionPlan, isAccessibleToUser, isSelectable = true }) => (
  <div className={cx(styles.root)}>
    <div className={styles.image}>
      <img src={plan.imageUri} alt={plan.name} />
    </div>
    <div className={styles.content}>
      <div>
        <div className={styles.name}>{plan.name}</div>
        <h2 className={cx(styles.price, { withFee: !!plan.activationFee })}>
          {t('price', { price: toCurrency(plan.price) })}
          {!!plan.activationFee && (
            <div className={styles.fee}>
              /mo {t('activationFee', { activationFee: toCurrency(plan.activationFee) })}
            </div>
          )}
          {!plan.activationFee && (
            <div className={styles.fee}>
              /mo
            </div>
          )}
        </h2>
        <div className={styles.planFeaturesTitle}>
          {t('planFeaturesTitle')}
        </div>
        <ul className={styles.options}>
          {plan.description && plan.description.split('|').map((item, index) => (
            <li key={index} className={styles.option}>{item}</li>
          ))}
        </ul>
      </div>
      <AccessWrapper {...(isAccessibleToUser ? 
        { off : [USER_ROLES.subscriptionUser] } : 
        { off : [] })}>
        <div className={styles.button}>
          <Button
            onClick={() => onSelectSubscriptionPlan(plan.id)}
            fluid
          >
            {isSelectable ? t('selectPlanButton') : t('notifyPlanButton')}
          </Button>
        </div>
      </AccessWrapper>
    </div>
  </div>
)

export default PlanItem
